import { ChatGptIcon } from '@/app/Indexer/components/SeoAiAdvice';
import { ActionTip } from '@/app/Indexer/components/ActionTip';
import type { LighthouseDetails } from '../api/types/analysisApiTypes';
import {
  buildSpeedAdviceChatUrl,
  getSpeedOptimizationIssues
} from '../lib/speed-ai-prompt';

type Props = {
  url: string;
  details: LighthouseDetails;
  auditId: string;
};

const SpeedAiAdvice = ({ url, details, auditId }: Props) => {
  const issue = getSpeedOptimizationIssues(details).find(
    item => item.auditId === auditId
  );
  if (!issue) return null;

  const tip = 'توضیح این مشکل و راه‌حل بهینه‌سازی با ChatGPT';

  return (
    <ActionTip tip={tip}>
      <a
        className="d-inline-flex align-items-center gap-1"
        aria-label={tip}
        href={buildSpeedAdviceChatUrl(url, details, [issue])}
        target="_blank"
        rel="noreferrer"
        style={{
          color: '#10a37f',
          fontSize: '1rem',
          lineHeight: 1,
          marginInlineStart: '0.75rem',
          textDecoration: 'none'
        }}
      >
        <ChatGptIcon />
      </a>
    </ActionTip>
  );
};

export default SpeedAiAdvice;
